$box-shadow: 0 0 15px 0 rgb(0 0 0 / 15%);

// styles for ux-checkbox element with media
.ux-checkbox-tile {
  box-shadow: $box-shadow;
  cursor: pointer;
  display: flex;
  flex-flow: column wrap;
  outline: 2px solid transparent;
  position: relative;

  &--active {
    outline: 2px solid $color-green;
  }

  &__top-wrapper {
    height: 0;
    overflow: hidden;
    padding-bottom: 56.25%;
    position: relative;
    width: 100%;
  }

  &__top-wrapper img {
    height: auto;
    left: 50%;
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
  }

  &__description {
    background-color: $color-white;
    border-bottom: 1px solid $color-gray-borders;
    height: 100%;
    left: 0;
    opacity: 0;
    overflow: hidden;
    overflow-y: auto;
    padding: 30px 30px 40px;
    pointer-events: none;
    position: relative;
    position: absolute;
    top: 0;
    transform: height 2s ease;
    transition: opacity $animationSpeed-normal $animationEasing-easeInOut;
    width: 100%;
  }

  &__description--active {
    opacity: 1;
    pointer-events: auto;
  }

  &__description-close {
    cursor: pointer;
    position: absolute;
    right: 15px;
    top: 15px;
  }

  &__bottom-wrapper {
    align-items: center;
    display: flex;
    justify-content: space-between;
    padding: 35px 30px;
    position: relative;
  }

  &__tag {
    background-color: $color-gray-text;
    border-radius: 2px;
    color: $color-white;
    font-size: $size-text-small;
    height: 30px;
    left: 30px;
    padding: 6px 15px;
    position: absolute;
    text-align: center;
    text-transform: uppercase;
    top: 0;
    transform: translate(0, -50%);
    width: auto;
    z-index: $z-index-checkbox-tile-elements;

    &--warning {
      background-color: $color-orange;
    }
  }

  &__checkbox-container {
    align-items: center;
    display: flex;
    position: relative;
  }

  &__description-toggle {
    -webkit-appearance: none;
    -moz-appearance: none;
    background: $color-white;
    border: 0;
    color: $color-black;
    cursor: pointer;
    display: block;
    padding: 0 10px;
    text-align: center;
    text-decoration: none;
    transform: translate(10px, 0);
    z-index: $z-index-checkbox-tile-elements;
  }
}
